import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { Divider } from '@hivebrite/design-system/Divider';

import type { EmailPublicationItemAttributes } from 'hb-builder/components/BuilderComponents/dynamic/EmailPublication/types';
import CheckboxSetting from 'hb-builder/components/common/SettingsLibrary/CommonSettings/CheckboxSetting';
import ColorSetting from 'hb-builder/components/common/SettingsLibrary/CommonSettings/ColorSetting';
import FontFamily from 'hb-builder/components/common/SettingsLibrary/CommonSettings/FontFamily';
import Padding from 'hb-builder/components/common/SettingsLibrary/CommonSettings/Padding';
import AccordionTitle from 'hb-builder/components/common/SettingsLibrary/SettingsDecoration/AccordionTitle';
import { useBuilderConfigContext } from 'hb-builder/hooks';
import type { ComponentSettingsTab } from 'hb-builder/types/settings';
import { isPaddingTooBig } from 'hb-builder/utils/attributes';

const Style = ({
  defaultAttributes,
  item,
  onChange,
  permissions,
}: ComponentSettingsTab<EmailPublicationItemAttributes>) => {
  const { can } = permissions || {};
  const {
    features: { color },
    hivebrite: { networkColors, networkTheming },
  } = useBuilderConfigContext();
  const colorSettingsProps = {
    color,
    networkColors,
    networkTheming,
  };
  const settingProps = { defaultAttributes, item, onChange };

  return (
    <Wrapper>
      <AccordionTitle isInitiallyOpen title={__('Section')}>
        <FontFamily
          settingKey="dynamicAttributes.fontFamily"
          {...settingProps}
        />
        <ColorSetting
          settingKey="containerBackgroundColor"
          title={__('Background color')}
          transparent
          {...settingProps}
          {...colorSettingsProps}
        />
        <Divider mt={0} />
        <Padding
          alert={{
            enabled: can?.alertOnCustomPadding,
            fillConditions: (padding) => isPaddingTooBig(padding, 30),
            message: s__(
              'Builder|Please check if this value displays well on mobile',
            ),
          }}
          settingKey="containerPadding"
          title={__('Padding (in pixels)')}
          {...settingProps}
        />
        <CheckboxSetting
          settingKey="fullWidth"
          title={__('Full width background')}
          {...settingProps}
        />
      </AccordionTitle>
    </Wrapper>
  );
};

export default Style;

const Wrapper = styled(Box).attrs(() => ({
  flexDirection: 'column',
  width: '100%',
}))``;
